export default "__VITE_ASSET__9940bcfa__"